<template>
    <div class="uk-container uk-container-expand">
        <router-link :to="{path: '/admin/gestion/utilisateur/create'}" class="btn btn-round my-3 border-0" style="background-color:#FFAB0E; color:#fff;" type="button" uk-toggle="target: #create_commande"><i class="fa fa-plus"></i> Créer un utilisateur</router-link>
        <router-link :to="{path: '/admin/gestion/utilisateur/role/edit'}" class="btn btn-round my-3 ml-2 border-0" style="background-color:#FFAB0E; color:#fff;" type="button" uk-toggle="target: #create_commande"><i class="fa fa-edit"></i>Role d'utilisateur</router-link>
        <div class="uk-card uk-card-default  uk-width-1-1@m mt-2 p-2">
            <h4>Liste des utilisateurs</h4>
            <div class="uk-overflow-auto">
                <table class="uk-table uk-table-striped">
                <thead>
                    <tr>
                        <th>Nom Complet</th>
                        <th>Numéro de téléphone</th>
                        <th>Email</th>
                        <th>Rôle</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    
                </tbody>
            </table>
            </div>
        </div>
    </div>
</template>
<script>
import { db, dbstore, auth, } from '../../main';
import Swal from "sweetalert2";

export default {
    data(){
        return{
            boutiques:[],
            access:0
        }
    },
    created(){
        this.access = this.$store.getters.user.data.role;
        if(this.access != 5){
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
         Toast.fire({
            icon: "error",
            title: '<span style="color:#B74334">Action non autorisée!</span>',
          });
          this.$router.push({ path: "/admin/livraison/encours"});
        }
    }
}
</script>